// frontend/src/index.js — React entry point
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ── Service Worker registration ───────────────────────────────────
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Register for Background Sync so the SW can re-trigger queue drain
      // on reconnect even if the tab wasn't open.
      if ('sync' in reg) {
        reg.sync.register('sync-offline-queue').catch(() => {});
      }
    }).catch(() => {});
  });
}
